<div class="wrapper horizontal-widget widget-apostas" ref:widget>
  <div class="ink-grid">
    <div class="column-group game">
      <div class="all-50 logo">
        <a href="https://apostas.sapo.pt" target="_blank">
          <img src="./images/logo_apostas.png" alt="" />
        </a>
      </div>
      <div
        class="all-50  logo_sponsor"
        data-sas-siteid="217941"
        data-sas-pageid="919315"
        data-sas-formatid="40452"
        data-sas-target=""
        data-pub="sas"
        data-pub-lazy="true"
      >
      </div>
      { #if current }
        <div class="all-100 team-wrapper">
          <div class="team push-right">
            <h2 class="team-name team-name--large">{ current.teams[0].name }</h2>
            <h2 class="team-name team-name--small">{ current.teams[0].initials }</h2>
            <div class="team-logo">
              <img src={ current.teams[0].logo } alt={ current.teams[0].name } />
            </div>
          </div>
          <span class="vs-wrapper">VS</span>
          <div class="team">
            <div class="team-logo">
              <img src={ current.teams[1].logo } alt={ current.teams[1].name } />
            </div>
            <h2 class="team-name team-name--large">{ current.teams[1].name }</h2>
            <h2 class="team-name team-name--small">{ current.teams[1].initials }</h2>
          </div>
        </div>
        <div class="all-50 large-80 medium-80 small-100 tiny-100 odds-container">
          <a href={ current.url } target="_blank">
            <OddsBlock
              odds={ current.odds['tr_1x2'] }
              providers={ providers }
            >
              <strong>As melhores odds para este jogo:</strong>
            </OddsBlock>
          </a>
        </div>
      { /if }
    </div>
    { #if count > 1 }
      <div class="all-60 large-90 medium-90 small-100 tiny-100 pager push-center">
        <button on:click="previous()" class="previous"></button>
        <button on:click="next()" class="next"></button>
      </div>
      <nav class="navigation">
        <ul>
          { #each (new Array(count).fill(null)) as item, index }
            <li>
              <button on:click="navigate(event, index)" class={ index === active ? 'active' : null }>{ index + 1 }</button>
            </li>
          { /each }
        </ul>
      </nav>
    { /if }
    <div style="margin-top: -20px; height: 30px; display:table; width:100%; text-align:center; line-height:.9em; padding: 0 1em;">
      <small style="color: #fff; vertical-align: middle; display: table-cell;">O jogo é proibido a menores de 18 anos. Aposte de forma responsável.</small>
    </div>
  </div>
</div>

<script>
  import { load as loadFeatured } from './../services/featured';
  import { load as loadGame } from './../services/game';
  import { load as loadProviders } from './../services/provider';

  import getParams from './../util/get-params';

  import OddsBlock from './odds-block.html';

  export default {
    data() {
      return {
        active: 0,
        games: [],
        game: null,
        providers: [],
        widget: 'horizontal',
        gameId: null,
        onload: null
      };
    },
    computed: {
      current: ({ gameId, game, games, active }) => gameId ? game : games[active],
      count: ({ games }) => games.length || 0
    },
    methods: {
      navigate(event, index) {
        event.preventDefault();
        this.set({ active: index });
      },
      previous() {
        const { count, active } = this.get();
        this.set({ active: active > 0 ? active - 1 : count - 1 });
      },
      next() {
        const { count, active } = this.get();
        this.set({ active: count - 1 > active ? active + 1 : 0 });
      },
      async loadFeatured () {
        const games = await loadFeatured(3);
        this.set({ games });
      },
      async loadGame (id) {
        const game = await loadGame(id);
        if(game){
          this.set({ game });
        }
        else{
          this.set({ gameId: null });
          await this.loadFeatured();
        }
      },
      async loadProviders () {
        const providers = await loadProviders();
        this.set({ providers });
      },
      async fetchData () {
        const { gameId } = this.get();
        try {
          gameId ? this.loadGame(gameId) : this.loadFeatured();
          this.loadProviders();
        } catch (error) {
          console.log(error);
        }
      },
      loadSponsor() {
        if (
          window &&
          window.SAPO &&
          window.SAPO.CPU &&
          window.SAPO.CPU.refresh
        ) window.SAPO.CPU.refresh('#widget-apostas .logo_sponsor');
      }
    },
    async oncreate() {
      if (window && window.location) {
        const { href } = window.location;
        const params = getParams(href);
        if (params.game_id) this.set({ gameId: params.game_id });
      }
      await Promise.all([ this.fetchData(), this.loadSponsor() ]);
      this.on('update', () => {
        this.fire('load', this.refs.widget);
      });
    },
    components: {
      OddsBlock
    }
  }
</script>

<style type="text/scss">
  @import './style/utilities.scss';

  .wrapper {
    background-color: color(scale, 10%);
    overflow: hidden;
  }

  .horizontal-widget {
    position: relative;
    /* height: 170px; */
    height: 200px;
    background: url('./images/background.jpg') no-repeat center center;
    background-size: cover;
    @include tablet-large {
      /* height: 168px; */
      height: 200px;
    }
    @include mobile {
      .ink-grid {
        padding: 0;
      }
    }
    .game {
      .logo,
      .logo_sponsor {
        height: 25px;
        padding-bottom: 0;
        a {
          display: block;
          padding: 4px 5px;
          padding-bottom: 0;
          @include mobile {
            padding: 8px 5px;
          }
        }
        img {
          height: 25px;
          @include mobile {
            height: 18px;
          }
          @include mobile-small {
            height: 15px;
          }
        }
      }
      .logo_sponsor {
        text-align: right;
      }
    }
    .odds-container {
      margin: auto;
      display: block;
      padding-left: 0;
    }
  }

  .team-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 0 8px 0;
    text-align: center;
    .vs-wrapper {
      color: white;
      font-weight: 400;
      text-align: center;
      margin: 0 8px;
      @include mobile {
        margin: 0;
      }
    }
    .team {
      display: flex;
      align-items: center;
      width: 100%;
      h2 {
        color: white;
        font-size: 1.3rem;
        font-weight: 300;
        margin-bottom: 0;
        font-size: 20px;
      }
      .team-name {
        display: block;
        @include mobile {
          font-size: 1rem;
        }
        &.team-name--small {
          display: none;
          @include mobile {
            display: block;
          }
        }
        &.team-name--large {
          @include mobile {
            display: none;
          }
        }
      }
      .team-logo {
        display: flex;
        display: -ms-flex;
        justify-content: center;
        align-items: center;
        width: 42px;
        height: 42px;
        background-color: white;
        border-radius: 50%;
        margin: 0 16px;
        @include mobile {
          margin: 0 8px;
        }
        img {
          width: 32px;
          height: 32px;
        }
      }
    }
  }

  .pager {
    position: absolute;
    top: 30px;
    right: 0;
    left: 0px;
    height: 50px;
    button {
      position: absolute;
      top: 0;
      width: 40px;
      height: 50px;
      background: url('./images/pager.svg') no-repeat;
      &:focus,
      &:active {
        outline: none;
      }
      &:hover {
        opacity: 0.8;
      }
      &:active {
        opacity: 0.5;
      }
    }
    .previous {
      left: 0;
      background-position: right bottom;
    }
    .next {
      right: 0;
      background-position: left top;
    }
  }

  .navigation {
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    width: 70px;
    margin: 0 auto;
    ul {
      margin: 4px 0 0;
      padding: 0;
      list-style: none;
      li {
        display: inline-block;
      }
    }
    button {
      width: 10px;
      height: 10px;
      padding: 0;
      margin: 0 5px;
      border: 1px solid #ccc;
      border-radius: 50%;
      text-indent: -99999em;
      overflow: hidden;
      &.active {
        background-color: #d43614;
        border-color: #d43614;
      }
    }
  }
</style>